import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class SonyDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default SonyDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/sony/DeviceSetup.js